import { TEXT_AREA_MAX_LENGTH } from '@constants';
import { stringConstraints } from '@utils';
import { z } from 'zod';

export const issueSchema = z.object({
  issueInfo: stringConstraints('Enter details about the issue.').refine(
    (value) => value.length <= TEXT_AREA_MAX_LENGTH,
    {
      message: `Details must be ${TEXT_AREA_MAX_LENGTH} characters or less.`,
      path: ['issueInfo'],
    },
  ),
  locationOfIssueInfo: stringConstraints(
    'Enter details about the issue.',
  ).refine((value) => value.length <= TEXT_AREA_MAX_LENGTH || value === null, {
    message: `Details must be ${TEXT_AREA_MAX_LENGTH} characters or less.`,
    path: ['locationOfIssueInfo'],
  }),
});
